import axios from 'axios';
import config from '../config';
import BaseInterceptors from "../interceptors/BaseInterceptors";
import AuthInterceptors from "../interceptors/AuthInterceptors";

/**
 * Library for making secure HTTP Requests
 */
export default class SecureHttpLibrary {

    /**
     * SecureHttpLibrary constructor
     *
     * @param {string} baseURL
     * @param {object} headers
     */
    constructor (baseURL = config.http.GATEWAY_API_URL, headers = config.http.GATEWAY_API_HEADERS) {
        this._instance = axios.create({
            baseURL,
            headers,
            timeout: 30000
        });
        BaseInterceptors.addBaseInterceptors(this._instance);
        AuthInterceptors.addAuthInterceptors(this._instance);
    }

    /**
     * Sends a GET request
     *
     * @param {string} url
     * @param token
     * @param {object} params
     * @returns {AxiosPromise<any>}
     */
    get (url, token, params = {}) {
        return this._instance.get(url, {
            params: { ...params },
            headers: {
                [config.http.GATEWAY_TOKEN_AUTH_HEADER]: `Bearer ${token}`
            }
        });
    }

    /**
     * Sens a PUT request
     *
     * @param {string} url
     * @param data
     * @param {string} token
     * @param {object} params
     * @returns {AxiosPromise<any>}
     */
    put (url, data, token, params = {}) {
        return this._instance.put(url, data, {
            params: { ...params },
            headers: {
                [config.http.GATEWAY_TOKEN_AUTH_HEADER]: `Bearer ${token}`
            }
        });
    }

    /**
     * Sends a POST request
     * @param {string} url
     * @param {object} data
     * @param {string} token
     * @param {object} params
     * @returns {AxiosPromise | *}
     */
    post (url, data, token, params = {}) {
        return this._instance.post(url, data, {
            params: { ...params },
            headers: {
                [config.http.GATEWAY_TOKEN_AUTH_HEADER]: `Bearer ${token}`
            }
        });
    }

    /**
     * Sends a POST request with custom headers
     * @param url
     * @param data
     * @param token
     * @param headers
     * @param params
     * @returns {AxiosPromise<any>}
     */
    postCustomHeaders (url, data, token, headers, params = {}) {
        return this._instance.post(url, data, {
            params: { ...params },
            headers: {
                [config.http.GATEWAY_TOKEN_AUTH_HEADER]: `Bearer ${token}`,
                ...headers
            }
        });
    }

    download(url, token) {
        return this._instance.get(url, {
            responseType: 'arraybuffer',
            headers: {
                [config.http.GATEWAY_TOKEN_AUTH_HEADER]: `Bearer ${token}`,
            }
        })
    }

    /**
     * Sends a DELETE request
     *
     * @param {string} url
     * @param {string} token
     * @param {object} params
     * @returns {AxiosPromise | *}
     */
    del (url, token, params = {}) {
        return this._instance.delete(url, {
            params: { ...params },
            headers: {
                [config.http.GATEWAY_TOKEN_AUTH_HEADER]: `Bearer ${token}`
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/libraries/SecureHttpLibrary.js